<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="host" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.host')" :placeholderValue="$t('common.routing.host')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="port" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.port')" :placeholderValue="$t('common.routing.port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="uri" :disabled="readonly" :maxLength="512"
          :inputLabel="$t('common.routing.uri')" :placeholderValue="$t('common.routing.uri')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="login" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.login')" :placeholderValue="$t('common.routing.login')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="password" :disabled="readonly"
          :inputLabel="$t('common.routing.password')" :placeholderValue="$t('common.routing.password')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="timeout" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.timeout')" :placeholderValue="$t('common.routing.timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="connectTimeout" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.connect_timeout')" :placeholderValue="$t('common.routing.connect_timeout')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName !== '' && formatInName !== ''">
        <form-read-group-label-input :input-value="formatName"
          :inputLabel="$t('common.routing.format_name')" :placeholderValue="$t('common.routing.format_name')">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="formatName !== '' && formatInName !== ''">
        <form-read-group-label-input :input-value="formatInName"
         :inputLabel="$t('common.routing.format_out_name')" :placeholderValue="$t('common.routing.format_out_name')">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <label for="ssl-active">
          {{ $t('common.routing.ssl_active') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="sslActive" :disabled="readonly" id="ssl-active">
          <option value="1"> {{ $t('common.routing.yes') }} </option>
          <option value="0"> {{ $t('common.routing.no') }} </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-read-group-label-input :input-value="sslActive === 1 ? $t('common.routing.ftps') : $t('common.routing.sftp')"
          :inputLabel="$t('common.routing.type')" :placeholderValue="$t('common.routing.type')">
        </form-read-group-label-input>
      </b-col>
      <b-col v-if="sslActive !== '0'" sm="6" class="form-group">
        <label for="keystore">
          {{ $t('common.routing.keystore') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="keystore" :disabled="readonly" id="keystore">
          <option v-for="keystore in keystoreList" :key="keystore.id" :value="keystore.id"> {{ keystore.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="sslActive !== '0'" class="form-group">
        <label for="certificat">
          {{ $t('common.routing.certificat') }}
<!--          <span class="color-red"> * </span>-->
        </label>
        <select class="form-control" v-model="ca" :disabled="readonly" id="certificat">
          <option v-for="ca in caList" :key="ca.id" :value="ca.id"> {{ ca.name }} </option>
        </select>
      </b-col>
      <b-col sm="6" v-if="sslActive === '0'" class="form-group">
        <label for="ssh">
          {{ $t('common.routing.ssh') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="ssh" :disabled="readonly" id="ssh">
          <option value="" hidden disabled> {{ $t('common.routing.select_ssh_type') }} </option>
          <option v-for="ssh in sshList" :key="ssh.id" :value="ssh.id"> {{ ssh.name }} </option>
        </select>
      </b-col>
    </b-row>
    <level-control-form v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="controlConfig" :placementLevel="placementFTP"></level-control-form>
    <!--<certificate-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="certificateConfig" :placementCertificate="placementFTP"></certificate-form-global>
    <private-keys-form-global v-if="sslActive === '1'" :mode="mode" :readonly="readonly" v-model="privateKeysConfig" :placementPrivateKey="placementFTP"></private-keys-form-global>-->
    <form-accordion :title="$t('common.vop_provider.vop_provider')" :isTitleUpperCase="false" v-if="entitiesType === 'rvm'">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="vopProvider">
            {{ $t('common.vop_provider.name') }}
          </label>
          <select class="form-control" v-model="IdVopProvider" :disabled="readonly"  id="vopProvider">
            <option value="" hidden disabled> {{ $t('common.routing.select_name_vop_provider') }} </option>
            <option v-for="vopProvider in vopProviderList" :key="vopProvider.id" :value="vopProvider.id">
              {{ vopProvider.text }}
            </option>
          </select>
        </b-col>
      </b-row>
    </form-accordion>
  </div>
</template>
<script>

import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'
import formReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
    'level-control-form' : LevelControlForm,
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    prefilledURI: {
      type: String,
      default: ''
    },
    placementFTP: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    formatName: {
      get () {
        return this.inputValue.formatName
      },
      set (val) {
        this.inputValue = {
          formatName: val,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    formatInName: {
      get () {
        return this.inputValue.formatInName
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: val,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: val,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    host: {
      get () {
        return this.inputValue.host
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: val,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    port: {
      get () {
        return this.inputValue.port
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          login: this.inputValue.login,
          password: this.inputValue.password,
          port: val,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    login: {
      get () {
        return this.inputValue.login
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          login: val,
          password: this.inputValue.password,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    password: {
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          login: this.inputValue.login,
          password: val,
          port: this.inputValue.port,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    uri: {
      get () {
        return this.inputValue.uri
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: val,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    sslActive: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.sslActive
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: val,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    keystore: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.keystore
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: val,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    ca: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.ca
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: val,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    ssh: {
      get () {
        return this.inputValue.sslActive === undefined ? '' : this.inputValue.ssh
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: val,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    controlConfig:{
      get () {
        return this.inputValue.controlConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: val,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    certificateConfig:{
      get () {
        return this.inputValue.certificateConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: val,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    privateKeysConfig:{
      get () {
        return this.inputValue.privateKeysConfig
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: val,
          timeout: this.inputValue.timeout,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    timeout:{
      get () {
        return this.inputValue.timeout
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: val,
          connectTimeout: this.inputValue.connectTimeout,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    connectTimeout:{
      get () {
        return this.inputValue.connectTimeout
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout: val,
          IdVopProvider: this.inputValue.IdVopProvider
        }
      }
    },
    IdVopProvider:{
      get () {
        return this.inputValue.IdVopProvider === undefined ? '' : this.inputValue.IdVopProvider
      },
      set (val) {
        this.inputValue = {
          formatName: this.inputValue.formatName,
          formatInName: this.inputValue.formatInName,
          name: this.inputValue.name,
          host: this.inputValue.host,
          port: this.inputValue.port,
          login: this.inputValue.login,
          password: this.inputValue.password,
          uri: this.inputValue.uri,
          sslActive: this.inputValue.sslActive,
          keystore: this.inputValue.keystore,
          ca: this.inputValue.ca,
          ssh: this.inputValue.ssh,
          controlConfig: this.inputValue.controlConfig,
          certificateConfig: this.inputValue.certificateConfig,
          privateKeysConfig: this.inputValue.privateKeysConfig,
          timeout: this.inputValue.timeout,
          connectTimeout:  this.inputValue.connectTimeout,
          IdVopProvider: val
        }
      }
    },
  },
  data () {
    return {
      caList: [],
      keystoreList: [],
      sshList: [],
      vopProviderList: []
    }
  },
  created () {
    this.entitiesType = this.$route.params.entitiesType
    if (this.mode === 'create') {
      if (this.prefilledURI !== undefined || this.prefilledURI === '') {
        this.inputValue.uri = this.prefilledURI
      }
      this.inputValue.sslActive = "0"
    }
    // if (this.sslActive == 1){
    //   this.getCA()
    //   this.getKeyStore()
    // }
    // else{
    //   this.getSSH()
    // }
    this.getCA()
    this.getKeyStore()
    this.getSSH()
    this.getVopProvider()
  },
  methods: {
    getSSH () {
      let that = this
      this.$engine.firstOn().security.ssh.fetch()
      .then(resp => {
        let SSHList = {}

        SSHList = resp.data.ssh
        this.sshList = SSHList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getCA () {
      let that = this
      this.$engine.firstOn().security.ca.fetch()
      .then(resp => {
        let CAList = {}

        CAList = resp.data.ca
        this.caList = CAList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getKeyStore () {
      let that = this
      this.$engine.firstOn().security.keystore.fetch()
      .then(resp => {
        let privateKeysList = {}

        privateKeysList = resp.data.keystore

        this.keystoreList = privateKeysList
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.firstOn().vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          id: vopProvider.IdVopProvider,
          text: vopProvider.NameVopProvider,
          value: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}

</script>
